/*  this exists because we need to force angular to reload a route if it is clicked inside
    a link list. If left to its own devices it may not do the right thing because sometimes
    only the query string is different
 */
angular
    .module('TR')
    .directive('linklist', function ($location : ng.ILocationService,
        $route,
        $rootScope : ng.IRootScopeService,
        urlUtils) {

        return {
            restrict: 'A',
            scope:{},
            link: function (scope : ng.IScope, el : ng.IAugmentedJQuery){
                function stripAndParse(url) {
                    return urlUtils.parse(urlUtils.stripLeadingSlash(url));
                }

                let url = stripAndParse($location.path());
                $('a', el).click((e:any) => {
                    let linkPath = $(e.target).attr('href');
                    let linkUrl = stripAndParse(linkPath);
                    if(url.url === linkUrl.url) {
                        $route.reload();
                    }
                });
                scope.$on('$destroy', () => $('a', el).off());
                $rootScope.$on('$routeChangeSuccess', function () {
                    url = stripAndParse($location.path());
                });
            }
        };
    });
